export default __webpack_public_path__ + "static/media/brand-main-sm.0e544880.png";